import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class Wholesale extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

            salesOrders: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },

            salesOrderDetail: {
              rows: [],
              selectedRows: null,
              filters: {},
              sortColumn: null,
              sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchWholesale();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.wholesale && nextProps.wholesale != this.props.wholesale) {
          var salesOrders = {...this.state.salesOrders, rows: nextProps.wholesale};
          this.setState({salesOrders});
        }

        if (nextProps.salesOrderDetail && nextProps.salesOrderDetail != this.props.salesOrderDetail) {
            var salesOrderDetail = {...this.state.salesOrderDetail, rows: nextProps.salesOrderDetail.Batch_Order_Lines };
            console.log(salesOrderDetail);
            this.setState({salesOrderDetail});
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentWholesale(e) {
        e.preventDefault();
        const currentWholesale = this.state.selectedRows[0];
        this.props.resetCurrentWholesale();
        this.props.selectWholesale(currentWholesale);
        this.context.router.push('/wholesale/'+currentWholesale.Wholesale_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentWholesale();
        this.context.router.push('/wholesale/new')
    }

    voidOrder() {
        let newRows = this.state.salesOrders.rows;
        this.state.salesOrders.selectedRows.map(row => {
          this.props.voidSalesOrder(row.SalesOrder_id, 'salesOrders');
          newRows = newRows.filter(function (obj) {
            return obj.SalesOrder_id !== row.SalesOrder_id;
          });
          var salesOrders = {...this.state.salesOrders, rows: newRows};
          this.setState({salesOrders});
        });
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.salesOrders);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.salesOrders, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({salesOrders: state});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.salesOrders.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                var salesOrders = {...this.state.salesOrders, filters: newFilters};
                this.setState({ salesOrders });
            }

            // Handle the row select function

            const onRowSelect = rows => {
              var salesOrders = {...this.state.salesOrders, selectedRows: rows};
              this.setState({salesOrders});
            }

            const onRowClick = (rowIdx, row) => {
                this.props.fetchWholesaleOrderDetail(row.SalesOrder_id);
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'SONum',
                  name: <Translate value="so_no" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'Deliver_Customer_num',
                  name: <Translate value="customer_no" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'Deliver_CustomerName',
                  name: <Translate value="customer_name" />,
                  resizable: true,
                  sortable: true,
                  width: 189,
                  filterable: true,
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  width: 260,
                  filterable: true,
              },
              {
                  key: 'TotalPrice',
                  name: <Translate value="total_price" />,
                  resizable: true,
                  sortable: true,
                  width: 125,
                  filterable: true,
              },
              {
                  key: 'Sales_User_id',
                  name: <Translate value="sales" />,
                  resizable: true,
                  sortable: true,
                  width: 178,
                  filterable: true
              },
              {
                  key: 'SaleStatus',
                  name: <Translate value="status" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true,
              },
              {
                  key: 'UpdateTime',
                  name: <Translate value="document_date" />,
                  resizable: true,
                  sortable: true,
                  width: 170,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'DispatchDate',
                  name: <Translate value="schedule_shipping_date" />,
                  resizable: true,
                  sortable: true,
                  width: 200,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'ShipmentDate',
                  name: <Translate value="shipping_date" />,
                  resizable: true,
                  sortable: true,
                  width: 115,
                  filterable: true,
                  formatter: DateFormatter
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="Wholesale-dataGrid1">
                    <ReactDataGrid
                        rowKey='SalesOrder_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight / 3 * 2}
                        enableRowSelect='multi'
                        onRowSelect={onRowSelect}
                        onRowClick={onRowClick}
                        />
                </div></Col></Row>
            )
        }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderProductsTable() {
        if (this.props.detailIsLoading && !this.props.detailError) return <Spinner/>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.detailError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.salesOrderDetail);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.salesOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({salesOrderDetail: state});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                var salesOrderDetail = {...this.state.salesOrderDetail, filters: newFilters};
                this.setState({ salesOrderDetail });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="product_num" />,
                  resizable: true,
                  sortable: true,
                  width: 200
              },
              {
                  key: 'Name',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  width: 200,
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  width: 800,
              },
              {
                  key: 'Quantity',
                  name: <Translate value="quantity" />,
                  resizable: true,
                  sortable: true,
                  width: 120
              },
              {
                  key: 'MeasureUnit',
                  name: <Translate value="unit_of_measure" />,
                  resizable: true,
                  sortable: true,
                  width: 150
              },
              {
                  key: 'UnitPrice',
                  name: <Translate value="unit_price" />,
                  resizable: true,
                  sortable: true,
                  width: 147
              },
              {
                  key: 'Batch_PONum',
                  name: <Translate value="batch_num" />,
                  resizable: true,
                  sortable: true,
                  width: 150
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="Wholesale-dataGrid2">
                    <ReactDataGrid
                        rowKey='Wholesale_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={this.state.tableHeight / 3}
                        onRowUpdated={this.handleRowUpdated} />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const fullList = (<Translate value="full_list_table_sales_order" />);
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="wholesale" /></div>
                <br/>
                <Panel header={fullList}>
                  <Button className="btn btn-primary pull-right" type="submit" onClick={(event) => { this.clickNew(event) } } disabled={this.checkPermission("add_sales_order")}><em className="fa fa-save marginRightStyle" /><Translate value="create_so" /></Button>
                  <Button className="btn btn-primary pull-right" ><em className="fa fa-print marginRightStyle" /><Translate value="print" /></Button>
                  <Button className="btn btn-danger pull-right" onClick={() => {this.voidOrder() } }><em className="fa fa-trash marginRightStyle" /><Translate value="void" /></Button>
                    <h4><Translate value="sales_order_full_table" />S</h4>
                    <hr/>
                    {this.renderTable() }
                    <h4><Translate value="detail_information" /></h4>
                    <hr/>
                    {this.renderProductsTable() }
                </Panel>
            </ContentWrapper>
        );
    }
}



export default Wholesale;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/wholesale.jsx